import { Component, forwardRef, Input } from '@angular/core'
import { NG_ASYNC_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms'
import { AbstractValueAccessor } from '@mistergreen/shared/angular-directives/abstract-value-accessor'

let _uniqueIdCounter: number = 0

@Component({
    selector: 'mg-configurator-colorpicker',
    templateUrl: './configurator-colorpicker.component.html',
    styleUrls: ['./configurator-colorpicker.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ConfiguratorColorpickerComponent),
            multi: true,
        },
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: forwardRef(() => ConfiguratorColorpickerComponent),
            multi: true,
        },
    ],
})
export class ConfiguratorColorpickerComponent extends AbstractValueAccessor {
    @Input()
    public name: string = `configurator-color-component-${_uniqueIdCounter++}`

    colors: { value: any; description: any }[] = []

    get selectedDescription() {
        return this.selectedChild ? this.selectedChild.description : null
    }

    private get selectedChild() {
        return this.colors.find(({ value }) => value === this.value)
    }

    registerChild(childColor: { value: string; description: any }) {
        this.colors.push(childColor)
    }

    constructor() {
        super()
    }

    async validate() {
        const error = null
        return error
    }
}
